export default {
  meta: {
    title: '加价率分析'
  }
};
